import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import {
  FETCH_SAP_MONTHLY_DATA,
  SEND_SAP_INVOICE_B2C_RECORDS_CGST_CGST,
  SEND_SAP_INVOICE_B2C_RECORDS_IGST,
  GENERATE_EXCEL,
  SAP_FAULTY_BOOKING_REPORT,
  GET_SAP_OCPI_PARTNER_LIST,
  FETCH_SAP_OCPI_CREDS_LIST,
  ADD_SAP_OCPI_PARTNER_LIST,
  UPDATE_SAP_OCPI_PARTNER_LIST,
  DELETE_SAP_OCPI_PARTNER_LIST,
  GENERATE_SAP_INVOICES_WITH_GST,
  DOWNLOAD_SAP_INVOICES_WITH_GST,
  TRIGGER_LOGITAX_OCPI_INVOICES,
  FETCH_SAP_INVOICES_WITH_GST,
  QUERY_SAP_MONTHLY_DATA,
  GET_SIGNED_URL_FOR_EXCEL,
  DELETE_SAP_MONTHLY_DATA_RECORD,
  PAGINATION_INFO,
  FETCH_SAP_STATION_DETAILS,
  UPDATE_SAP_STATION_DETAILS,
} from 'actions/sap';

function* fetchSapMonthlyData(action) {
  try {
    const response = yield call(API.getSapMonthlyData, action.payload);
    yield put({ type: FETCH_SAP_MONTHLY_DATA.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_SAP_MONTHLY_DATA.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* generateExcel(action) {
  try {
    const response = yield call(API.generateExcel, action.payload);
    yield put({ type: GENERATE_EXCEL.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: GENERATE_EXCEL.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* sendSAPInvoiceB2CRecordsIGST(action) {
  try {
    const response = yield call(API.sendSAPInvoiceB2CRecordsIGST, action.payload);
    yield put({ type: SEND_SAP_INVOICE_B2C_RECORDS_IGST.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: SEND_SAP_INVOICE_B2C_RECORDS_IGST.FAIL, payload: { error: e } });
  }
}

function* sendSAPInvoiceB2CRecordsCGSTSGST(action) {
  try {
    const response = yield call(API.sendSAPInvoiceB2CRecordsCGSTSGST, action.payload);
    yield put({ type: SEND_SAP_INVOICE_B2C_RECORDS_CGST_CGST.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: SEND_SAP_INVOICE_B2C_RECORDS_CGST_CGST.FAIL, payload: { error: e } });
  }
}

function* sapFaultyBookingReport(action) {
  try {
    const response = yield call(API.sapFaultyBookingReport, action.payload);
    yield put({ type: SAP_FAULTY_BOOKING_REPORT.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: SAP_FAULTY_BOOKING_REPORT.FAIL, payload: { error: e } });
  }
}


//ocpi related items

function* getSapOcpiPartnerList(action) {
  try {
    const response = yield call(API.getSapOcpiPartnerList, action.payload);
    yield put({ type: GET_SAP_OCPI_PARTNER_LIST.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: GET_SAP_OCPI_PARTNER_LIST.FAIL, payload: { error: e } });
  }
}


function* fetchSapOcpiCredList(action) {
  try {
    const response = yield call(API.fetchSapOcpiCredList, action.payload);
    yield put({ type: FETCH_SAP_OCPI_CREDS_LIST.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_SAP_OCPI_CREDS_LIST.FAIL, payload: { error: e } });
  }
}

function* addSapOcpiCredList(action) {
  try {
    const response = yield call(API.addSapOcpiCredList, action.payload);
    yield put({ type: ADD_SAP_OCPI_PARTNER_LIST.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: ADD_SAP_OCPI_PARTNER_LIST.FAIL, payload: { error: e } });
  }
}

function* updateSapOcpiCredList(action) {
  try {
    const response = yield call(API.updateSapOcpiCredList, action.payload);
    yield put({ type: UPDATE_SAP_OCPI_PARTNER_LIST.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_SAP_OCPI_PARTNER_LIST.FAIL, payload: { error: e } });
  }
}

function* deleteSapOcpiCredList(action) {
  try {
    const response = yield call(API.deleteSapOcpiCredList, action.payload);
    yield put({ type: DELETE_SAP_OCPI_PARTNER_LIST.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_SAP_OCPI_PARTNER_LIST.FAIL, payload: { error: e } });
  }
}

function* generateSapInvoicesWithGst(action) {
  try {
    const response = yield call(API.generateSapInvoicesWithGst, action.payload);
    yield put({ type: GENERATE_SAP_INVOICES_WITH_GST.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: GENERATE_SAP_INVOICES_WITH_GST.FAIL, payload: { error: e } });
  }
}

function* downloadSapInvoicesWithGst(action) {
  try {
    const response = yield call(API.downloadSapInvoicesWithGst, action.payload);
    yield put({ type: DOWNLOAD_SAP_INVOICES_WITH_GST.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DOWNLOAD_SAP_INVOICES_WITH_GST.FAIL, payload: { error: e } });
  }
}

function* fetchSapInvoicesWithGst(action) {
  try {
    const response = yield call(API.fetchSapInvoicesWithGst, action.payload);
    yield put({ type: FETCH_SAP_INVOICES_WITH_GST.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_SAP_INVOICES_WITH_GST.FAIL, payload: { error: e } });
  }
}

function* triggerLogitaxOcpiInvoices(action) {
  try {
    const response = yield call(API.triggerLogitaxOcpiInvoices, action.payload);
    yield put({ type: TRIGGER_LOGITAX_OCPI_INVOICES.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: TRIGGER_LOGITAX_OCPI_INVOICES.FAIL, payload: { error: e } });
  }
}


function* querySapMonthlyData(action) {
  try {
    const response = yield call(API.querySapMonthlyData, action.payload);
    yield put({ type: QUERY_SAP_MONTHLY_DATA.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: QUERY_SAP_MONTHLY_DATA.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* getSignedUrlForExcel(action) {
  try {
    const response = yield call(API.getSignedUrlForExcel, action.payload);
    yield put({ type: GET_SIGNED_URL_FOR_EXCEL.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: GET_SIGNED_URL_FOR_EXCEL.FAIL, payload: { error: e } });
  }
}

function* deleteSapMonthlyData(action) {
  try {
    const response = yield call(API.deleteSapMonthlyData, action.payload);
    yield put({ type: DELETE_SAP_MONTHLY_DATA_RECORD.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_SAP_MONTHLY_DATA_RECORD.FAIL, payload: { error: e } });
  }
}

function* b2cPagination(action) {
  try {
    const response = yield call(API.b2cPagination, action.payload);
    yield put({ type: PAGINATION_INFO.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: PAGINATION_INFO.FAIL, payload: { error: e } });
  }
}


function* fetchSapStationDetails(action) {
  try {
    const response = yield call(API.fetchSapStationDetails, action.payload);
    yield put({ type: FETCH_SAP_STATION_DETAILS.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_SAP_STATION_DETAILS.FAIL, payload: { error: e } });
  }
}

function* updateSapStationDetails(action) {
  try {
    const response = yield call(API.updateSapStationDetails, action.payload);
    yield put({ type: UPDATE_SAP_STATION_DETAILS.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_SAP_STATION_DETAILS.FAIL, payload: { error: e } });
  }
}


function* sap() {
  yield takeLatest(QUERY_SAP_MONTHLY_DATA.REQUEST, fetchSapMonthlyData);
  yield takeLatest(SEND_SAP_INVOICE_B2C_RECORDS_IGST.REQUEST, sendSAPInvoiceB2CRecordsIGST);
  yield takeLatest(SEND_SAP_INVOICE_B2C_RECORDS_CGST_CGST.REQUEST, sendSAPInvoiceB2CRecordsCGSTSGST);
  yield takeLatest(GENERATE_EXCEL.REQUEST, generateExcel);
  yield takeLatest(SAP_FAULTY_BOOKING_REPORT.REQUEST, sapFaultyBookingReport);

  //ocpi related items

  yield takeLatest(GET_SAP_OCPI_PARTNER_LIST.REQUEST, getSapOcpiPartnerList);
  yield takeLatest(FETCH_SAP_OCPI_CREDS_LIST.REQUEST, fetchSapOcpiCredList);
  yield takeLatest(ADD_SAP_OCPI_PARTNER_LIST.REQUEST, addSapOcpiCredList);
  yield takeLatest(UPDATE_SAP_OCPI_PARTNER_LIST.REQUEST, updateSapOcpiCredList);
  yield takeLatest(DELETE_SAP_OCPI_PARTNER_LIST.REQUEST, deleteSapOcpiCredList);
  yield takeLatest(GENERATE_SAP_INVOICES_WITH_GST.REQUEST, generateSapInvoicesWithGst);
  yield takeLatest(DOWNLOAD_SAP_INVOICES_WITH_GST.REQUEST, downloadSapInvoicesWithGst);
  yield takeLatest(FETCH_SAP_INVOICES_WITH_GST.REQUEST, fetchSapInvoicesWithGst);
  yield takeLatest(TRIGGER_LOGITAX_OCPI_INVOICES.REQUEST, triggerLogitaxOcpiInvoices);
  yield takeLatest(QUERY_SAP_MONTHLY_DATA.REQUEST, querySapMonthlyData);
  yield takeLatest(GET_SIGNED_URL_FOR_EXCEL.REQUEST, getSignedUrlForExcel);
  yield takeLatest(DELETE_SAP_MONTHLY_DATA_RECORD.REQUEST, deleteSapMonthlyData);
  yield takeLatest(FETCH_SAP_STATION_DETAILS.REQUEST, fetchSapStationDetails);
  yield takeLatest(UPDATE_SAP_STATION_DETAILS.REQUEST, updateSapStationDetails);

  //pagination 
  yield takeLatest(PAGINATION_INFO.REQUEST, b2cPagination);
}
export default sap;
